module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('md-layout', {
    staticClass: "register-doctor main--content",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.doctor.plan_status == 2) ? _c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "height": "110px !important",
      "background": "#ffeb3b",
      "color": "black",
      "padding": "20px",
      "border-radius": "5px",
      "margin-bottom": "10px",
      "text-align": "justify"
    }
  }, [_vm._v("\n          Usted adeuda " + _vm._s(_vm.doctor.plan_owed) + "\n          " + _vm._s(_vm.doctor.user.plan.period_months == 12 ? "año(s)" : "mes(es)") + ".\n          "), _c('br'), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.renewPlan()
      }
    }
  }, [_vm._v("Pagar ahora")])], 1) : _vm._e(), _vm._v(" "), (_vm.doctor.plan_status == 1) ? _c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "height": "auto !important",
      "background": "rgb(180, 219, 134)",
      "color": "black",
      "padding": "20px",
      "border-radius": "5px",
      "margin-bottom": "10px",
      "text-align": "justify"
    }
  }, [_vm._v("\n          Usted esta al dia en sus pagos.\n          "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-12 col-xs-12 no-padder"
  }, [_c('div', {
    staticClass: "profile-image"
  }, [_c('img', {
    staticClass: "img-responsive img-rounded",
    attrs: {
      "src": _vm.profile_image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "camera_upload",
    on: {
      "click": _vm.uploadAvatarIcon
    }
  }, [_c('md-icon', [_vm._v("photo_camera")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    staticStyle: {
      "width": "100%",
      "display": "block",
      "text-align": "center",
      "margin-top": "20px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("formAvatar") && _vm.errors.formAvatar.length > 3 ?
    _vm.errors.formAvatar :
    ""))]), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "formAvatar",
      "method": "POST",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "id": "fileAvatar",
      "type": "file",
      "name": "avatar"
    },
    on: {
      "change": _vm.onAvatarChange
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translate.pages.profile_doctor["avatar-btn"]) + "\n          ")])])]), _vm._v(" "), (_vm.doctor.user) ? _c('div', {
    staticClass: "col-md-10 col-sm-12 col-xs-12 no-padder"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('code')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.code))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.doctor.code),
      callback: function($$v) {
        _vm.doctor.code = $$v
      },
      expression: "doctor.code"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("code") ? _vm.errors.code[0] : ""))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('name')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.name))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.doctor.name),
      callback: function($$v) {
        _vm.doctor.name = $$v
      },
      expression: "doctor.name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("name") ? _vm.errors.name[0] : ""))])], 1)], 1), _vm._v(" "), (_vm.doctor.is_institution !== 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('lastname'),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.lastname))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.doctor.lastname),
      callback: function($$v) {
        _vm.doctor.lastname = $$v
      },
      expression: "doctor.lastname"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("lastname") ? _vm.errors.lastname[0] : ""))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.doctor.is_institution !== 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('lastname2'),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.lastname2))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.doctor.lastname2),
      callback: function($$v) {
        _vm.doctor.lastname2 = $$v
      },
      expression: "doctor.lastname2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("lastname2") ? _vm.errors.lastname2[0] : ""))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('email')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.email))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.doctor.email),
      callback: function($$v) {
        _vm.doctor.email = $$v
      },
      expression: "doctor.email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("email") ? _vm.errors.email[0] : ""))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('phone')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.phone))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": "required|numeric|min:6|max:12",
      "data-vv-name": "doctor.phone",
      "required": ""
    },
    model: {
      value: (_vm.doctor.phone),
      callback: function($$v) {
        _vm.doctor.phone = $$v
      },
      expression: "doctor.phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: 912345")]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("phone") ? _vm.errors.phone[0] : ""))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fafafa"
    }
  }, [(_vm.doctor.is_institution == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#959ea6 !important",
      "font-size": "12px"
    }
  }, [_vm._v("Provincia "), _c('span', {
    staticStyle: {
      "color": "#f26061"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "options": _vm.regions,
      "placeholder": "Provincia",
      "on-change": _vm.changeRegion,
      "required": ""
    },
    model: {
      value: (_vm.doctor.region.label),
      callback: function($$v) {
        _vm.doctor.region.label = $$v
      },
      expression: "doctor.region.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("region_id") ? _vm.errors.region_id : ""))])], 1) : _vm._e(), _vm._v(" "), (_vm.doctor.is_institution == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#959ea6 !important",
      "font-size": "12px"
    }
  }, [_vm._v("Comuna "), _c('span', {
    staticStyle: {
      "color": "#f26061"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "options": _vm.cities,
      "placeholder": "Comuna",
      "on-change": _vm.changeCity,
      "required": ""
    },
    model: {
      value: (_vm.doctor.city.label),
      callback: function($$v) {
        _vm.doctor.city.label = $$v
      },
      expression: "doctor.city.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("comunity") ? _vm.errors.comunity : ""))])], 1) : _vm._e(), _vm._v(" "), (_vm.doctor.is_institution == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('street'),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.street))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.doctor.street),
      callback: function($$v) {
        _vm.doctor.street = $$v
      },
      expression: "doctor.street"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("street") ? _vm.errors.street : ""))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.doctor.is_institution == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('number'),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.number))]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.doctor.number),
      callback: function($$v) {
        _vm.doctor.number = $$v
      },
      expression: "doctor.number"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("number") ? _vm.errors.number[0] : ""))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "profile--check"
  }, [_c('div', {
    staticClass: "col-md-6 mar-top-1"
  }, [_c('md-input-container', {
    staticStyle: {
      "margin": "0 !important"
    }
  }, [_c('md-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Buscar Especialidad..."
    },
    model: {
      value: (_vm.filterSpecialities),
      callback: function($$v) {
        _vm.filterSpecialities = $$v
      },
      expression: "filterSpecialities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "multiple checkbox-list"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.translate.pages.profile_doctor.fields.specialities) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, _vm._l((_vm.filteredSpecialities), function(speciality) {
    return _c('md-checkbox', {
      key: speciality.id,
      staticClass: "option md-primary text--color",
      on: {
        "change": function($event) {
          _vm.onChosen($event, speciality.id)
        }
      },
      model: {
        value: (speciality.checked),
        callback: function($$v) {
          speciality.checked = $$v
        },
        expression: "speciality.checked"
      }
    }, [_vm._v(_vm._s(speciality.name))])
  }))]), _vm._v(" "), _c('label', {
    staticClass: "subtitle",
    class: {
      error: _vm.errors.specialities.invalid
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.select_specialties))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 checkbox-list checkbox-options"
  }, [_c('div', [_c('md-checkbox', {
    staticClass: "md-primary text--color",
    attrs: {
      "id": "notification_appointment",
      "md-theme": "green",
      "name": "notification_appointment"
    },
    model: {
      value: (_vm.doctor.notification_appointment),
      callback: function($$v) {
        _vm.doctor.notification_appointment = $$v
      },
      expression: "doctor.notification_appointment"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields
    .notification_appointment))])], 1), _vm._v(" "), _c('div', [_c('md-checkbox', {
    staticClass: "md-primary text--color",
    attrs: {
      "id": "notification_mail",
      "md-theme": "green",
      "name": "notification_mail"
    },
    model: {
      value: (_vm.doctor.notification_mail),
      callback: function($$v) {
        _vm.doctor.notification_mail = $$v
      },
      expression: "doctor.notification_mail"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.notification_mail))])], 1), _vm._v(" "), _c('div', [_c('md-checkbox', {
    staticClass: "md-primary text--color",
    attrs: {
      "id": "notification_sms",
      "md-theme": "green",
      "name": "notification_sms"
    },
    model: {
      value: (_vm.doctor.notification_sms),
      callback: function($$v) {
        _vm.doctor.notification_sms = $$v
      },
      expression: "doctor.notification_sms"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.translate.pages.profile_doctor.fields.notification_sms) + "\n                    (" + _vm._s(_vm.doctor.user.sms_used) + " /\n                    " + _vm._s(_vm.doctor.user.plan.max_sms) + ")\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty('password'),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.password))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    ref: "password",
    attrs: {
      "type": "password",
      "md-no-cache": "true",
      "autocomplete": "new-password",
      "data-vv-name": "password",
      "data-vv-rules": "required|min:6",
      "required": ""
    },
    model: {
      value: (_vm.doctor.password),
      callback: function($$v) {
        _vm.doctor.password = $$v
      },
      expression: "doctor.password"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("password") ? _vm.errors.password[0] : "") + "\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasOwnProperty(
        'password_confirmation'
      ),
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.fields.confirm_password))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "password",
      "data-vv-name": "password_confirmation",
      "data-vv-rules": "required|min:6|confirmed:password",
      "required": ""
    },
    model: {
      value: (_vm.doctor.password_confirmation),
      callback: function($$v) {
        _vm.doctor.password_confirmation = $$v
      },
      expression: "doctor.password_confirmation"
    }
  }), _vm._v(" "), (_vm.doctor.password != _vm.doctor.password_confirmation) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty("password_confirmation") ?
    _vm.errors.password_confirmation[0] :
    ""))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.prefix == 'CL') ? _c('div', {
    staticClass: "bonus_container",
    staticStyle: {
      "background": "#eaeaea75",
      "width": "100%",
      "height": "auto",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#00bcd4",
      "color": "white",
      "padding": "10px",
      "border-radius": "10px"
    }
  }, [_vm._v("\n                Bonificación a Pacientes AMOL\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("\n                Ingrese el Descuento que ofrece para cada tipo de Paciente\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_particular"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.in_bon_particular),
      callback: function($$v) {
        _vm.doctor.in_bon_particular = $$v
      },
      expression: "doctor.in_bon_particular"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_fonasa"
    }
  }, [_vm._v("FONASA")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento de Copago")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.in_bon_fonasa),
      callback: function($$v) {
        _vm.doctor.in_bon_fonasa = $$v
      },
      expression: "doctor.in_bon_fonasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bonus_set"
  }, [_c('label', {
    attrs: {
      "for": "bon_isapre"
    }
  }, [_vm._v("ISAPRE")]), _vm._v(" "), _c('small', [_vm._v("Porcentaje de descuento de Copago")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('NumberInputSpinner', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "inputClass": 'spin_input',
      "buttonClass": 'spin_btn',
      "integerOnly": true
    },
    model: {
      value: (_vm.doctor.in_bon_isapre),
      callback: function($$v) {
        _vm.doctor.in_bon_isapre = $$v
      },
      expression: "doctor.in_bon_isapre"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "10px",
      "padding": "15px !important"
    }
  }, [_c('b', [_vm._v("Condiciones específicas:")]), _vm._v(" Me comprometo a cumplir estos\n                descuentos a todos los Pacientes de AMOL por el plazo mínimo de\n                un año, y mientras esté vigente mi Registro en AMOL.\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.doctor.code != '11111111-1' || _vm.doctor.code != '76403501-1') ? _c('md-button', {
    staticClass: "md-raised md-primary md-size margin-t btn--blue",
    attrs: {
      "type": "submit",
      "disabled": _vm.process
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.save_changes_btn))]) : _vm._e()], 1)]), _vm._v(" "), _c('md-dialog', {
    ref: "dialog1",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_vm._v(_vm._s(_vm.alert.msg))]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('dialog1')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.profile_doctor.close_dialog))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 col-md-12"
  }, [_c('h1', [_vm._v("Sincronizacion con Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "rgb(213, 88, 90)",
      "color": "white",
      "padding": "10px"
    }
  }, [_vm._v("\n            Debido a nuevas políticas de FACEBOOK esta opción se encuentra\n            unicamente disponible para Paginas de Facebook que cuentan con mas\n            de 2000 seguidores.\n          ")]), _vm._v(" "), (_vm.FacebookSyncStatus == 4) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "height": "90px !important",
      "background": "#e84949",
      "color": "white",
      "padding": "20px",
      "border-radius": "5px",
      "text-align": "justify"
    }
  }, [_vm._v("\n            Ocurrio un error en la sincronizacion, recuerde que todos los\n            permisos solicitados son necesarios para la integracion\n          ")]) : _vm._e(), _vm._v(" "), (_vm.fbStatus == 3) ? _c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "height": "110px !important",
      "background": "#8bc34a",
      "color": "white",
      "padding": "20px",
      "border-radius": "5px",
      "text-align": "justify"
    }
  }, [_vm._v("\n            Ya sincronizo Agenda Medica ONLINE con FACEBOOK en su pagina:\n            "), _c('b', [_vm._v(_vm._s(_vm.fbPageData.name))]), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.FacebookRemoveTab()
      }
    }
  }, [_vm._v("Desincronizar")])], 1) : _vm._e(), _vm._v(" "), (_vm.fbStatus != 342432) ? _c('fb-signin-button', {
    attrs: {
      "params": _vm.fbSignInParams
    },
    on: {
      "success": _vm.onSignInSuccess,
      "error": _vm.onSignInError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fbStatus == 5) ? _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#8bc34a",
      "color": "white",
      "padding": "10px"
    }
  }, [_vm._v("\n            Sincronización exitosa.\n          ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 col-md-12"
  }, [_c('h1', [_vm._v("Integración en su WEB")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#8bc34a",
      "color": "white",
      "padding": "10px"
    }
  }, [_vm._v("\n            Con el siguiente código usted o su programador podrá insertar en su\n            sitio web el "), _c('b', [_vm._v("sistema de agendamiento exclusivo")]), _vm._v(" de manera\n            fácil y rápida.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#8bc34a",
      "color": "white",
      "padding": "10px"
    }
  }, [_vm._v("\n            Si desea añadir mas de un boton en la misma pagina solo debe copiar\n            el boton de "), _c('b', [_vm._v("Agendar Ahora")]), _vm._v(" y cambiarle el id=\"btnModal\"\n            añadiendole un 1, de la siguiete manera id=\"btnModal1\" asi\n            susecivamente hasta llegar a el id=\"btnModal10\".\n            "), _c('br'), _vm._v("\n            De ser otra pagina debe copiar el codigo completo.\n          ")]), _vm._v(" "), _c('div', [_c('pre', {
    staticClass: "code"
  }, [_vm._v("                      <button id=\"btnModal\" class=\"btnStyle\">\n                          "), _c('br'), _vm._v("                           \n                           \n                          Agendar Ahora\n                      "), _c('br'), _vm._v("                           \n                           \n                          <span class=\"ir\">\n                          &nbsp;\n                          </span>\n                      "), _c('br'), _vm._v("                      </button>\n                      "), _c('br'), _vm._v("\n                      <div id=\"tvesModal\" class=\"modalContainer\">\n                          "), _c('br'), _vm._v("                            <div class=\"modal-content\">\n                          "), _c('br'), _vm._v("                             \n                          <span class=\"close\">× </span>\n                          "), _c('br'), _vm._v("                             \n                          <h2>Modal </h2>\n                          "), _c('br'), _vm._v("                             \n                          <iframe\n                          "), _c('br'), _vm._v(" src=\""), _c('br'), _vm._v("https://globales."), _c('br', {
    staticClass: "is--movile"
  }), _vm._v("agendaenlinea.cl/"), _c('br', {
    staticClass: "is--movile"
  }), _vm._v("exclusive/"), _c('br', {
    staticClass: "is--movile"
  }), _vm._v(_vm._s(_vm.doctor.id)), _c('br'), _vm._v("\"\n                          frameborder=\"0\""), _c('br'), _vm._v(" style=\"height:600px;"), _c('br'), _vm._v(" width:100%\" ></iframe>\n                          "), _c('br'), _vm._v("                            </div>\n                      "), _c('br'), _vm._v("                      </div>\n                      "), _c('br'), _vm._v("                      <script"), _c('br'), _vm._v(" src=\""), _c('br'), _vm._v("https://amol.cl/iframe/"), _c('br', {
    staticClass: "is--movile"
  }), _vm._v("funtionsIframe.js\""), _c('br'), _vm._v("></script>\n                      "), _c('br'), _vm._v("                      <link"), _c('br'), _vm._v(" rel=\"stylesheet\""), _c('br'), _vm._v(" href=\""), _c('br'), _vm._v("https://amol.cl/iframe/"), _c('br', {
    staticClass: "is--movile"
  }), _vm._v("stylesIframe.css"), _c('br'), _vm._v("\">\n            ")])])])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf4b25e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/ProfileDoctor.vue
// module id = 669
// module chunks = 1